module.exports = __webpack_public_path__ + "img/ai02.21205b4a.svg";